import {Button} from '@material-ui/core';
import React from 'react';
import Modal from 'Shared/components/Modal';
import {toFormattedDateTime} from 'Shared/utilities/DateFormatter';
import './ExternalUploadReturnToBrokerModel.sass';

export type ExternalUploadReturnModalProps = {
  onClose: () => void;
  returnComments: string;
  removalReason: string;
  recentActionDate?: Date | null;
};

const ExternalUploadReturnToBrokerModel = (props: ExternalUploadReturnModalProps) => {
  const {onClose} = props;
  return (
    <Modal open onClose={onClose} title="Return Details">
      <div className="external-upload-return-modal">

        <div className="external-upload-return-modal__details">
          <h6 className="title">Reason</h6>
          <p>{props.removalReason}</p>

          <h6 className="title">Date</h6>
          <p>{toFormattedDateTime(props.recentActionDate!)}</p>
        </div>

        <div className="external-upload-return-modal__details">
          <h6 className="title">Comments</h6>
          <p> {props.returnComments}</p>
        </div>

        <div className="modal__footer modal__footer-external-upload-return">
          <Button className="modal__footer-external-upload-return-actions" variant="contained" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalUploadReturnToBrokerModel;
